import React, { Component } from "react";
import { Button, Dropdown, Input, Menu, Upload, DatePicker, Select, Divider, Form } from "antd";
import ListViewFilters from "swfrontend/MDM/MDMScreens/ListView/ListViewFilters";
import ColumnListViewFilters from "swfrontend/MDM/MDMScreens/ListView/ColumnListViewFilters";
import { path } from "../../../App/ScreenRouters";

const { Search } = Input;
const { Option } = Select; 


export default class CustomListHeader extends Component {

    state = {
        addButton: true,
        deleteButton: true,
        editButton: true,
        filterClicked: false,
        columnfilterClicked: false,
        searchValue: "",
        searchClicked: false,
    };

    handleSearch = (value) => {
        this.setState({searchClicked: true, searchValue: value});
        this.props.onSearch(value);
    };

    handleFilterClick = () => {
        this.setState({filterClicked: true}, () => {
            this.setState({filterClicked: false});
        });
    };

    handleColumnFilterClick = () => {
        this.setState({columnfilterClicked: true}, () => {
            this.setState({columnfilterClicked: false});
        });
    };

    handleBeforeUpload = (file) => {
        this.props.excelImport(file);
        return false;
    };

    render() {
        const menu = (
            <Menu>
                <Menu.Item
                    key="1"
                    hidden={!this.props.deleteButton}
                    onClick={this.props.deleteField}
                >
                    Delete data
                </Menu.Item>
                <Menu.Item key="2" onClick={this.props.excelExport}>
                    Export to excel
                </Menu.Item>
                <Menu.Item
                    hidden={this.props.uploadExcelButton}>
                    <Upload
                        beforeUpload={this.handleBeforeUpload}
                        accept={".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"}
                        fileList={[]}
                        multiple="false">
                        Import from excel
                    </Upload>
                </Menu.Item>
                <Menu.Item key="4">
                    {/* <a href={`${path}/progress-import-template.xlsx`} download>Download Template</a> */}
                    <a onClick={this.props.downloadTemplate}>Download Template</a>
                </Menu.Item>
            </Menu>
        );

        if (this.props.showListHeader === false) {
            return null;
        } else {
            return (
                <div>
                    <div className="header_buttons">
                        <div
                            className="search_header"
                            hidden={this.props.hide_search ? this.props.hide_search : false}>
                            <Search
                                placeholder="Search in table"
                                onSearch={this.handleSearch}
                                value={this.state.searchValue}
                                onChange={(e) => {
                                    this.setState({searchValue: e.target.value});
                                }}
                                style={{float: "left", width: "50%"}}
                                hidden={this.props.hide_search ? this.props.hide_search : false}
                                enterButton/>
                            <div style={{display: "inline-block"}}>
                                <Button
                                    type="link"
                                    hidden={!this.state.searchClicked}
                                    onClick={() => {
                                        this.handleSearch("");
                                        this.setState({searchClicked: false});
                                        this.props.onResetSearch();
                                    }}>
                                    Reset
                                </Button>
                            </div>
                            {/* <div 
                                style={{ display: "inline-block", width: "30%", marginLeft: "5%" }}
                            >
                                <DatePicker
                                    value={this.props.monthFilter}
                                    picker="month"
                                    onChange={this.props.onChangeMonthFilter}
                                />
                            </div> */}
                        </div>
                        <Button
                            className={"add_header"}
                            type="primary"
                            onClick={this.props.addField}
                            hidden={!this.props.addButton}>
                            New
                        </Button>
                        <Dropdown className={"drop_down_header"} overlay={menu}>
                        <Button hidden={this.props.addAction} className={"drop_down_header"}>Action</Button>
                        </Dropdown>

                        <Divider />
                        <div >
                            <Form
                                // form={form}
                                // ref={this.props.formRef}
                                name="filter-data"
                                onFinish={this.props.applyFilter}
                                style={{ "display": "grid", "grid-template-columns": "1fr 1fr 1fr 1fr 0.1fr",  "grid-gap": "1.5rem" }}
                            >
                            <Form.Item name="month">
                                <DatePicker
                                    style={{ width: "100%" }}
                                    // value={this.props.monthFilter}
                                    picker="month"
                                    // onChange={this.props.onChangeMonthFilter}
                                />
                            </Form.Item>
                            <Form.Item name="location">
                                <Select
                                    
                                    placeholder="Location"
                                    allowClear={true}
                                    style={{ width: "100%" }}
                                    // onSelect={(value) => this.props.fetchDependentDropdownValues('MstProgram', 'location.location_id=', value)}
                                >
                                    {this.props['mstLocation'].map((item) => (
                                        <Option key={item.location_id} value={item.location_id}>
                                            {item.location_name}
                                        </Option>
                                    ))}
                                </Select>
                            </Form.Item>
                            <Form.Item name="stream">
                                <Select
                                    placeholder="Program"
                                    allowClear={true}
                                    style={{ width: "100%" }}
                                    // onSelect={(value) => this.props.fetchDependentDropdownValues('MstProject', 'program.program_id=', value)}
                                >
                                    {this.props['mstProgram'].map((item) => (
                                        <Option key={item.program_id} value={item.program_id}>
                                            {item.program_name}
                                        </Option>
                                    ))}
                                </Select>
                            </Form.Item>
                            <Form.Item name="project">
                                <Select
                                    showSearch
                                    optionFilterProp="children"
                                    placeholder="Project"
                                    allowClear={true}
                                    style={{ width: "100%" }}
                                >
                                    {this.props['mstProject'].map((item) => (
                                        <Option key={item.project_id} value={item.project_id}>
                                            {item.project_name}
                                        </Option>
                                    ))}
                                </Select>
                            </Form.Item>
                            <Form.Item>
                                <Button
                                    className={"add_header"}
                                    type="primary"
                                    htmlType="submit"
                                >
                                    Apply
                                </Button>
                            </Form.Item>
                            </Form>
                        </div>

                        {/* <Button
                            className={"drop_down_header"}
                            onClick={this.handleFilterClick}
                            hidden={this.props.addFilters}
                            >
                            Add Filters
                        </Button> */}
                        {this.props.columnFilterButton ? (
                            <Button
                                className={"drop_down_header"}
                                onClick={this.handleColumnFilterClick}>
                                Column Filter
                            </Button>) : null}

                        <ColumnListViewFilters
                            {...this.props}
                            handleColumnFilterClick={this.state.columnfilterClicked}/>
                        <ListViewFilters
                            {...this.props}
                            handleFilterClick={this.state.filterClicked}/>
                    </div>
                </div>
            );
        }
    }
}
